module.exports = __webpack_public_path__ + "img/harry_potter_06_and_the_half_blood_prince.02ae1bd0.jpg";